export enum headerStatus {
  COMING_SOON = 'COMING_SOON',
  PREVIEW = 'PREVIEW',
  LIVE = 'LIVE',
  ENDED = 'ENDED',
  BETA = 'BETA',
}
